import Requester from "./Requester";

interface CreateDTO {
    clientId: number
    amount: number
    currency: string
}

export function getInvoices(limit: number = 10, page: number = 1) {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/invoices', [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
    ]))
}

export function getInvoice(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/invoices/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`api/invoices/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/invoices`), values)
}

export default {
    create,
    getInvoices,
    getInvoice,
    destroy,
}